import { Box, Text } from "@chakra-ui/react";
import React from "react";
import {
  AddressType,
  buildRouteUrl,
  Button,
  investorPortalRoutes,
  ModelId,
} from "../../../../..";
import {
  AdminDashboardCustodianRoutes,
  AdminDashboardRoutesAccountSections,
  custodianIdParam,
} from "../../../../defines/routes/admin-dashboard";
import { managerDashboardRoutes } from "../../../../defines/routes/sponsor-dashboard";
import { useGetDynamicConfig } from "../../../../dynamic-config";
import DynamicConfigFlags from "../../../../dynamic-config/configs";

export const AddressDisclaimer = ({
  type,
  accountId,
  isVisible = false,
  withMarginLeft = true,
  isCustodianOnMallcop = false,
}: {
  type: AddressType;
  accountId: ModelId;
  isVisible?: boolean;
  withMarginLeft?: boolean;
  isCustodianOnMallcop?: boolean;
}) => {
  const isMallcopDashboard = useGetDynamicConfig(
    DynamicConfigFlags.IS_MALLCOP_DASHBOARD,
  );
  const isDashboard = useGetDynamicConfig(DynamicConfigFlags.DASHBOARD_MANAGER);

  const tabNamePostfix = isMallcopDashboard
    ? "/" + AdminDashboardRoutesAccountSections.Settings
    : "";

  const routePrefix = isDashboard ? managerDashboardRoutes.HOME : "";

  if (!isVisible) {
    return null;
  }
  const lowercasedType = type.toLowerCase();

  const ownerOfTheCheck = isDashboard ? "The investor's check" : "Your";
  return (
    <Box mt={1} ml={withMarginLeft ? "30px" : "0px"}>
      <Text textStyle="bodyRegular" color="text.grey">
        {type === AddressType.Other
          ? ownerOfTheCheck +
            " will be sent to the new address entered in the fields below."
          : `${ownerOfTheCheck} will be sent to the ${lowercasedType} associated with your account.`}
      </Text>
      {type !== AddressType.Other && (
        <Button
          link
          to={
            isCustodianOnMallcop
              ? buildRouteUrl(AdminDashboardCustodianRoutes.CUSTODIAN_DETAILS, {
                  [custodianIdParam]: accountId as string,
                })
              : buildRouteUrl(
                  routePrefix +
                    investorPortalRoutes.accountDetails +
                    tabNamePostfix,
                  {
                    id: accountId as string,
                  },
                )
          }
          w="max-content"
        >
          Update {lowercasedType}
        </Button>
      )}
    </Box>
  );
};
